import { NgModule, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import {
    Router
} from "@angular/router";
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as Sentry from "@sentry/angular";
// import {CommonModule } from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { ReactiveFormsModule } from "@angular/forms";
import { ClipboardModule } from 'ngx-clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
// #fake-start#
import { FakeAPIService } from './_fake/fake-api.service';
// #fake-end#

import { DropdownMenu2Component } from './components/dropdown-menu2/dropdown-menu2.component';
import { AlertService } from './services/alerts.service';
import { UserPermissionsService } from './services/user-permissions.service';
import { SlotReleaseCalendarService } from './services/slot-release-calendar.service';
import { TopbarComponent } from './components/topbar/topbar.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SidebarFooterComponent } from './components/sidebar/sidebar-footer/sidebar-footer.component';
import { SidebarLogoComponent } from './components/sidebar/sidebar-logo/sidebar-logo.component';
import { RangePipe } from './range.pipe';
import { FileSizePipe } from './file-size.pipe';
import { LayoutModule } from './_metronic/layout';
import { NavbarComponent } from './components/navbar/navbar.component';
import { TruncatePipe } from './components/navbar/navbar.component';
import { VersionBannerComponent } from './components/version-banner/version-banner.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BreadcrumbModule } from "./components/breadcrumb/breadcrumb.module";
import { LoadingModule } from './components/loading/loading.module';
import {
    ConfirmImportModalComponent
} from './modules/games/game-upcoming/confirm-import-modal/confirm-import-modal.component';
import {FrontendErrorInterceptor} from "./interceptors/frontend-error.interceptor";
import {AuthModule} from "./modules/auth/auth.module";
import {GoogleLoginProvider, SocialAuthServiceConfig, SocialLoginModule} from "@abacritt/angularx-social-login";
import {NavbarSearchComponent} from "./components/navbar/navbar-search/navbar-search.component";
import { NavbarEntitiesComponent } from './components/navbar/navbar-entities/navbar-entities.component';
import {HasPermissionModule} from "./directives/user-has-permissions/user-has-permissions.module";
import {SharedModule} from "./modules/shared/shared.module";
import {RightClickMenuModule} from "./components/right-click-menu/right-click-menu.module";
import {NavbarSuggestionBoxComponent} from "./components/navbar/navbar-suggestion-box/navbar-suggestion-box.component";
import {HexagonMenuComponent} from "./components/hexagon-menu/hexagon-menu.component";
import {HexagonSuggestionBoxComponent} from "./components/hexagon-menu/hexagon-suggestion-box/hexagon-suggestion-box.component";


@NgModule({
    declarations: [
        AppComponent,
        DropdownMenu2Component,
        TopbarComponent,
        SidebarComponent,
        SidebarFooterComponent,
        SidebarLogoComponent,
        RangePipe,
        FileSizePipe,
        NavbarComponent,
        VersionBannerComponent,
        NavbarSearchComponent,
        NavbarSuggestionBoxComponent,
        NavbarEntitiesComponent,
        TruncatePipe,
        // Standalone redesign of NavbarComponent — declared so it compiles, but not yet
        // referenced by any template (see hexagon-menu.component.ts header comment).
        HexagonMenuComponent,
        HexagonSuggestionBoxComponent,
    ],
    imports: [
        // CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot(),
        HttpClientModule,
        ReactiveFormsModule,
        ClipboardModule,
        FormsModule,
        // #fake-start#
        environment.isMockEnabled
            ? HttpClientInMemoryWebApiModule.forRoot(FakeAPIService, {
                passThruUnknownUrl: true,
                dataEncapsulation: false,
            })
            : [],
        // #fake-end#
        AppRoutingModule,
        InlineSVGModule.forRoot(),
        NgbModule,
        LayoutModule,
        MatSnackBarModule,
        BreadcrumbModule,
        LoadingModule,
        AuthModule,
        SocialLoginModule,
        HasPermissionModule,
        SharedModule,
        RightClickMenuModule,
    ],
    providers: [
        AlertService,
        UserPermissionsService,
        SlotReleaseCalendarService,
        ConfirmImportModalComponent,
        DatePipe,
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false,
            }),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => {
            },
            deps: [Sentry.TraceService],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: FrontendErrorInterceptor,
            multi: true
        },
        {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                providers: [
                    {
                        id: GoogleLoginProvider.PROVIDER_ID,
                        // One Tap defaults to enabled in this library, which triggers Google's
                        // own native account-chooser prompt on top of the explicit sign-in
                        // button — on mobile that native prompt takes over most of the screen,
                        // so it's disabled below the same breakpoint the login card itself
                        // switches at (768px), leaving only the explicit button there.
                        provider: new GoogleLoginProvider(environment.GOOGLE_AUTH_CLIENT_ID, {
                            oneTapEnabled: window.innerWidth >= 768
                        })
                    }
                ],
                onError: (err) => {
                    console.error(err);
                }
            } as SocialAuthServiceConfig,
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
